import { Subscription, Transmit } from '@adonisjs/transmit-client'
import { createContext, useContext, useReducer } from 'react'

type ConnectionID = 'whatsmenu' | 'keeta' | 'nine-nine'

interface TransmitContextData {
  connections: Map<ConnectionID, Transmit>
  subscriptions: Map<`${ConnectionID}:${string}`, Subscription>
  createConnection: ({ options, connectionID }: { options: ConstructorParameters<typeof Transmit>[0], connectionID: ConnectionID }) => { connection: Transmit }
  createSubscription: ({ connectionID, channel }: { connectionID: ConnectionID, channel: string }) => Promise<{ subscription: Subscription | null }>
}

interface TransmitProviderProps {
  children: React.ReactNode
}

export const TransmitContext = createContext<TransmitContextData>(
  {} as TransmitContextData
)

const initialState = {
  connections: new Map<ConnectionID, Transmit>(),
  subscriptions: new Map<`${ConnectionID}:${string}`, Subscription>()
}
const transmitReducer = (state: typeof initialState, action: any): typeof initialState => {
  switch (action.type) {
    case 'ADD_CONNECTION':
      return {
        ...state,
        connections: state.connections.set(action.payload.connectionID, action.payload.connection)
      }
    case 'ADD_SUBSCRIPTION':
      return {
        ...state,
        subscriptions: state.subscriptions.set(`${action.payload.connectionId as ConnectionID}:${action.payload.channel}`, action.payload.subscription)
      }
  }
  console.log(state);

  return state
}

export const TransmitProvider = ({ children }: TransmitProviderProps) => {
  const [{ connections, subscriptions }, dispatch] = useReducer(transmitReducer, initialState)

  const createConnection = ({ options, connectionID }: { options: ConstructorParameters<typeof Transmit>[0], connectionID: ConnectionID }) => {
    const connection = new Transmit(options)


    dispatch({
      type: 'ADD_CONNECTION',
      payload: { connection, connectionID }
    })

    return { connection }
  }

  const createSubscription = async ({ connectionID, channel }: { connectionID: ConnectionID, channel: string }) => {
    console.log('createSubscription', connections, connectionID, channel)
    const connection = connections.get(connectionID)

    if (!connection) {
      console.log('Connection not found',connection)
      return { subscription: null }
    }

    const subscription = connection.subscription(channel)
    await subscription.create()

    dispatch({
      type: 'ADD_SUBSCRIPTION',
      payload: { connectionId: connectionID, channel, subscription }
    })

    return { subscription }
  }

  return (
    <TransmitContext.Provider value={{
      connections,
      subscriptions,
      createConnection,
      createSubscription
    }}>
      {children}
    </TransmitContext.Provider>
  )
}

export const useTransmit = (): TransmitContextData => useContext(TransmitContext)


